// auth.js
export const LOGOUT = 'LOGOUT';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';

// navigation
export const SET_PERIOD_VALUE = 'SET_PERIOD_VALUE';
export const SET_PERIOD_TYPE_SELECTED = 'SET_PERIOD_TYPE_SELECTED';
export const SET_MANUFACTURING_ORDER = 'SET_MANUFACTURING_ORDER';
